import axios from 'axios';

import { url } from 'utils/urls';

const withCredentials = true;
const headers = {
    "Content-Type": "application/json",
    'Accept': 'application/json',
};


export const asyncUpdateColorConfiguration = (colorConfigUUID, customColorSchema) => axios.put(`${url.rating.url}/v1/rating-units/color-configurations/${colorConfigUUID}`, customColorSchema, { withCredentials });

export const asyncExportRatingsAnalytics = ({format, siteUUID}) => axios.get(`${url.rating.url}/v1/ratings/analytics/export?format=${format}&siteUUID=${siteUUID}`, { headers, withCredentials });

export const asyncGetRatingsConfig = (accountUUID, siteUUID, siteUrl)  => axios.get(`${url.rating.url}/v1/rating-units/configurations?accountUUID=${accountUUID}&siteUUID=${siteUUID}&siteUrl=${siteUrl}`, { withCredentials });

export const asyncGetCode = ({siteUUID, productType}) => axios.get(`${url.rating.url}/v1/rating-units/code?siteUUID=${siteUUID}&productType=${productType}`, { withCredentials });

export const asyncUpdateAddOnsConfig = ({path, request, configUUID}) => axios.put(`${url.rating.url}/v1/rating-units/${path}/${configUUID}`, request , { withCredentials });

export const asyncGetRatingsUnitCode = siteUUID => axios.get(`${url.rating.url}/v1/rating-units/code?siteUUID=${siteUUID}&productType=RATING_UNIT`, { withCredentials });

export const asyncRequestRatingWidget = (accountUUID) => axios.post(`${url.ppa.url}/v1/accounts/${accountUUID}/product-access-requests`, { 'productType': 'RATINGS' }, { withCredentials });

export const asyncHasRatingsUnit = (accountUUID) => axios.get(`${url.ppa.url}/v1/accounts/${accountUUID}/product-access-requests?productType=RATINGS`, { withCredentials });

export const asyncSaveRatingsGeneral = (configID, data) => axios.put(`${url.rating.url}/v1/rating-units/general-configurations/${configID}`, data, { withCredentials })
